// @flow
import type { SessionState } from '../domain/State';
import type { AppState } from '../../../../types/State';
import {
  BEGIN_SESSION,
  CLOSE_SESSION,
  SWITCH_RADIO,
  SWITCH_RADIO_SUCCESS,
  SWITCH_RADIO_FAILED,
  RENEW_SESSION,
  RENEW_SESSION_SUCCESS,
  RENEW_SESSION_FAILED,
  RETRIEVE_NO_SESSION,
  UPDATE_RADIOUSER,
  SESSION_FETCHED,
} from '../actions/sessionActions';

export const INITIAL_STATE: SessionState = {
  token: undefined,
  user: undefined,
  radioUser: undefined,
  radio: undefined,
  isSwitchingRadio: false,
  isAuthenticated: false,
  isFetched: false,
  isRenewing: false,
  error: undefined,
};

export const getStation = (state: AppState) => (state.session.radio ? state.session.radio.callSign : '');
export const getRadio = (state: AppState) => (state.session.radio);
export const getToken = (state: AppState): string => state.session.token || '';
export const getUser = (state: AppState) => state.session.user;

export default (state: SessionState = INITIAL_STATE, action: any): SessionState => {
  switch (action.type) {
    case BEGIN_SESSION:
      return {
        ...state,
        token: action.token,
        user: action.user,
        isAuthenticated: true,
        isRenewing: false,
      };
    case SESSION_FETCHED:
      return {
        ...state,
        isFetched: true,
      };
    case CLOSE_SESSION:
      return {
        ...state,
        isAuthenticated: false,
        token: undefined,
        user: undefined,
        radioUser: undefined,
        radio: undefined,
      };
    case SWITCH_RADIO:
      return {
        ...state,
        isSwitchingRadio: true,
        error: undefined,
      };
    case SWITCH_RADIO_SUCCESS:
      return {
        ...state,
        isSwitchingRadio: false,
        radio: action.radio,
        radioUser: action.radioUser,
      };
    case SWITCH_RADIO_FAILED:
      return {
        ...state,
        isSwitchingRadio: false,
        error: action.error,
      };
    case RENEW_SESSION:
      return {
        ...state,
        isRenewing: true,
        isFetched: true,
      };
    case RENEW_SESSION_SUCCESS:
      return {
        ...state,
        token: action.token,
        isRenewing: false,
        isFetched: true,
      };
    case RENEW_SESSION_FAILED:
      return {
        ...state,
        isRenewing: false,
        isFetched: true,
      };
    case RETRIEVE_NO_SESSION:
      return {
        ...state,
        isFetched: true,
      };
    case UPDATE_RADIOUSER:
      return {
        ...state,
        radioUser: action.radioUser,
        isFetched: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/session/reducers/sessionReducer.js